
import React from "react"
import { Grid, Paper, Button, TableCell, TableRow, TableHead, Table, Typography, makeStyles } from "@material-ui/core"
import MigaPan from '../../../../app/orussystem/component/MigaPan';
import { useEffect, useState } from "react";
import { ModalAños } from "../Administracion/ModalAños";
import { getAños, updateStatus } from "../../../domain/api/AdministracionApi"
import { ListAños } from '../Administracion/ListAños';
import { useDispatch } from "react-redux";
import { ModalTowButton } from "../../../../utils/modals/modalInfoTowButton";
import { Store } from "react-notifications-component";
import { panelUsersAuthStyle } from "../../../users_auth/panelUsersAuthStyle"
import theme from "../../../../app/config/themaConfig";

const useStyles = makeStyles((theme) => ({
    title: {
        marginBottom: '30px',
        marginTop: '30px',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
    },
    TableCell: {
        color: '#0088FE',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        fontWeight: 'bold',
        fontSize: '17px',

    },
    title: {
        marginBottom: '30px',
        marginTop: '30px',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        marginLeft: '10%'
    },
    box: {
        marginLeft: '1%',
        marginTop: '3%',
        marginBottom: '3%'
    }, searchContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end', // Alinea al final (derecha)
        paddingRight: theme.spacing(1), // Agrega un poco de espacio a la derecha
    },
    searchInputContainer: {
        display: 'flex',
        borderRadius: '20px 0px 0px 20px',
        height: '32px',
        fontSize: '16px',
    },
    searchInput: {
        border: '1px solid  #b6b7b7',
        borderRadius: '20px 0px 0px 20px',
        padding: '4px 8px',
        height: '100%',
        fontSize: 'inherit',
        outline: 'none',
        flex: 1,
    },
    searchButton: {
        background: '#0088FE',
        color: 'white',
        borderRadius: '0px 50px 50px 0px',
        padding: '8px 16px',
        fontSize: '14px',
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        width: '100%'
    },
}));



export default function Años() {
    const clases = panelUsersAuthStyle()
    const classes = useStyles()

    const [isOpenModal, setisOpenModal] = useState(false)
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [busqueda, setBusqueda] = useState("")
    const [loading, setLoading] = useState(false)
    const dispath = useDispatch()
    const [listDate, setlistDate] = useState([])
    const [totalElements, setTotalElements] = useState("")
    const [stateUser, setstateUser] = useState("")
    const [isOpenModalChangeStatus, setisOpenModalChangeStatus] = useState(false)

    const fetchData = async () => {
        setLoading(true);

        try {
            const Años = await getAños(dispath);

            if (Años && Años.respuesta) {
                // Clonar la lista para evitar modificar el estado directamente
                const sortedList = [...Años.respuesta];

                // Ordenar la lista por año de menor a mayor
                sortedList.sort((a, b) => a.year - b.year);

                setlistDate(sortedList);
                setTotalElements(Años.totalElements);
            } else {

            }
        } catch {

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const changeStatus = async () => {
        const response = await updateStatus(dispath, stateUser.year)
        try {

            if (response) {
                handledAlert("Actualizado Exitosamente!", `Año  ${stateUser.year} actualizado con exito!`, "success")
                setisOpenModalChangeStatus(false)
                cargarListaAños()
            } else {
                handledAlert("Ocurrio un erro!", "Ocurrio un error al cambiar el estado", "danger")
            }

        } catch {
            handledAlert("Ocurrio un erro!", "Error interno", "danger")
        }
    }

    const handledAlert = (title, message, type) => {
        Store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });
        setTimeout(() => {
            // init()
        }, 1000);
    }
    const handledOpenModalState = (data) => {
        setstateUser(data)
        setisOpenModalChangeStatus(true)
    }

    const cargarListaAños = async () => {
        setLoading(true);
        const Años = await getAños(dispath);
        try {
            if (Años && Años.respuesta) {
                const sortedList = Años.respuesta.sort((a, b) => b.year - a.year);

                setlistDate(sortedList);
                setTotalElements(Años.totalElements);
            } else {

            }
        } catch {

        } finally {
            setLoading(false);
        }
    };


    const primaryColor = theme.palette.primary.main;


    return (

        <>
            {isOpenModal && <ModalAños
                setopenMondal={setisOpenModal}
                rowsPerPage={rowsPerPage}
                busqueda={busqueda}
                isOpen={isOpenModal}
                reload={cargarListaAños}

            />}

            {isOpenModalChangeStatus && <ModalTowButton
                setopenMondal={setisOpenModalChangeStatus}
                isOpen={isOpenModalChangeStatus}
                reload={cargarListaAños}
                title={"Señor usuario"}
                Messange={"¿Esta seguro de cambiar el estado de este año?"}
                handledAccept={changeStatus}


            />}

            <Grid item xs={12} >
                <br></br>
                <br></br>

                <MigaPan
                    namePage="Años"
                    to="/"
                    namePage2="Administracion"
                    to2="/Administracion"

                >
                    Home
                </MigaPan>
            </Grid>

            <Paper className={classes.paper} >
                <Grid item xs={12}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} className={classes.searchContainer} >
                            <Typography style={{ fontSize: '25px', fontWeight: 'bold', marginTop: '1%', marginBottom: '2%', marginRight: '85%' }} color='primary'>Años </Typography>


                            <Button variant="contained" color="primary" onClick={() => setisOpenModal(true)} style={{ alignContent: 'right' }} >
                                CREAR AÑO
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Table>
                                <TableHead color='primary'>
                                    <TableRow color='primary'>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '20%', color: primaryColor }}>Año</TableCell>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '25%', color: primaryColor }}>Fecha de creación</TableCell>
                                        <TableCell className={clases.TableCell} style={{ width: '25%', paddingLeft: '7%', color: primaryColor }}>Estado</TableCell>
                                        <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', color: primaryColor }}>Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                            </Table>
                        </Grid>
                        <Grid item xs={12}>
                            <ListAños
                                rows={listDate}
                                classes={clases}
                                totalElement={0}
                                changeStatus={handledOpenModalState}
                                isLoanding={loading}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
        </>
    )





}